import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';

declare let $: any;

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  categories: any[] = [];
  loading: boolean = false;
  deleting: boolean = false;
  searchString: string = '';
  modalDelete = false;
  categoryIdToDelete: any;
  showCreateCategoryModal = false;
  showEditCategoryModal = false;
  categoryIdForSubCategories: string | null = null;
  categoryIdForSubSubCategories: string | null = null;
  selectedCategoryId!: string;
  timekitProjects: any;

  constructor(
    private apiService: ApiService,
    public themingService: ThemingService,
    public router: Router,
    private settingsService: SettingsService,
    private lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.getCategories();
  }

  async getCategories() {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getCategories(this.themingService.shopId);

      const categories = Array.isArray(response[0]) ? response[0] : [];
      const timekitProjects = Array.isArray(response[1]) ? response[1] : [];

      // Asignar proyecto a cada categoría
      categories.forEach(category => {
        const project = timekitProjects.find((p: any) =>
          p.timekitProjectId === category.timekitProjectId
        );
        category.projectName = project ? project.projectName : 'No Project';
      });

      this.categories = categories;
      this.timekitProjects = timekitProjects;

    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      this.loading = false;
    }
  }

  showSubCategories(categoryId: string) {
    this.categoryIdForSubCategories = categoryId;
    this.categoryIdForSubSubCategories = null;
  }

  showSubSubCategories(categoryId: string) {
    this.categoryIdForSubSubCategories = categoryId;
    this.categoryIdForSubCategories = null;
  }

  backToCategories() {
    this.categoryIdForSubCategories = null;
    this.categoryIdForSubSubCategories = null;
  }

  setEditingCategory(categoryId: string) {
    this.settingsService.setEditingCategory(categoryId);
  }

  async deleteCategory(response: number) {
    if (response && this.categoryIdToDelete !== null) {
      this.loading = true;
      try {
        const category = this.categories.find(cat => cat.categoryId === this.categoryIdToDelete);
        if (category && category.categoryImageUrl) {
          await this.deleteImage(category.categoryImageUrl);
        }
        await this.lambdaService.deleteCategory(this.themingService.shopId, this.categoryIdToDelete);
        this.getCategories();
        $('#deleteCategoryModal').modal('show');
      } catch (error) {
        console.error('Error deleting category:', error);
      } finally {
        this.loading = false;
        this.modalDelete = false;
      }
    } else {
      this.modalDelete = false;
    }
  }

  async deleteImage(imageUrl: string) {
    try {
      await this.lambdaService.deleteFile(imageUrl);
    } catch (error) {
      console.log('Error deleting image:', error);
    }
  }

  closeModal() {
    $('#deleteCategoryModal').modal('hide');
  }

  openCreateCategoryModal() {
    this.showCreateCategoryModal = true;
  }

  closeCreateCategoryModal() {
    this.showCreateCategoryModal = false;
  }

  openEditCategoryModal(categoryId: string) {
    this.selectedCategoryId = categoryId;
    this.showEditCategoryModal = true;
  }

  handleCategoryUpdated() {
    this.showEditCategoryModal = false;
    this.getCategories();
  }

  closeEditCategoryModal() {
    this.showEditCategoryModal = false;
  }

  handleCategoryCreated() {
    this.showCreateCategoryModal = false;
    this.getCategories();
  }
}
